module.exports = __webpack_public_path__ + "assets/01c3dd6dd849fc66f4f6345117f0fe3e.svg";